export const INPUT_TYPE = {
    TEXT: 'text',
    DATE: 'date',
    MULTI_SELECT: 'multi-select',
    SEARCH: 'search',
} as const;

export type INPUT_TYPE = (typeof INPUT_TYPE)[keyof typeof INPUT_TYPE];
